import React, { Suspense } from "react"
import ReactDOM from "react-dom"
import * as path from "./constants/Paths"
import ReactHtmlParser from "react-html-parser"

// import BookingStarter from './components/bookingStarter'
const BookingStarter = React.lazy(() => import(/* webpackPrefetch: true */ "./components/bookingStarter"))

export default class ParkingBookingStarterTeaser {
  constructor(elem) {
    const self = this
    self.elem = elem
    self.config = {}
    self.init()
    return this
  }
  init() {
    const self = this
    const parkingBookingStarterTeaserContainer = self.elem
    if (parkingBookingStarterTeaserContainer) {
      self.config =
        (parkingBookingStarterTeaserContainer.dataset.parkingBookingstarterTeaser &&
          JSON.parse(parkingBookingStarterTeaserContainer.dataset.parkingBookingstarterTeaser)) ||
        {}
      const textKeys = (self.config["textKeys"] && self.config["textKeys"]["bookingStarter"]) || {}
      const searchData = self.config["searchData"] || {}
      const locale = self.config["locale"] || "da"
      ReactDOM.render(
        <Suspense fallback={ReactHtmlParser(parkingBookingStarterTeaserContainer.innerHTML)}>
          <div className="booking-teaser">
            <BookingStarter
              searchData={searchData}
              headline={textKeys.headline}
              subHeadline={textKeys.subHeadline}
              svgIcon={self.config?.svgIcon}
              textKeys={textKeys}
              noHeader={textKeys.headline === undefined}
              performParkingSearch={self.performParkingSearch}
              showDefaultDates={false}
              locale={locale}
              noPrefill={true}
              slimVersion={true}
              noWidth={true}
              buttonClasses={`button--large button--general-inverted ${self.config?.buttonBackgroundColor || ""} `}
              backgroundColor={self.config?.sectionBackgroundColor || ""}
              bottomPadding={self.config?.bottomPadding || ""}
              topPadding={self.config?.topPadding || ""}
              fontColor={self.config?.fontColor || ""}
              buttonFontColor={self.config?.buttonFontColor || ""}
              config={self.config}
              wide={true}
              teaser={true}
              flow={false}
              campaignCode={false}
              formClasses={null}
              replaceHistory={false}
              searchOnBlur={false}
              leadTimeInHours={textKeys.leadTimeInHours || 1.0}
            />
          </div>
        </Suspense>,
        parkingBookingStarterTeaserContainer,
      )
    }
  }

  performParkingSearch = (arrivalDate, arrivalTime, departureDate, departureTime, voucher, affiliateCode) => {
    const locale = this.config["locale"] || "da"
    const url = `${path.SEARCH(locale)}?ad=${arrivalDate}&at=${arrivalTime}&dd=${departureDate}&dt=${departureTime}${
      voucher ? "&voucher=" + voucher : ""
    }${affiliateCode ? "&affiliate=" + affiliateCode : ""}`
    window.location.assign(url)
  }
}

//window.parkingBookingStarterTeaser = new ParkingBookingStarterTeaser()
